import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { APP_STORE_ID } from '../constants/store-links';
import { isMobileWebView } from '../utilities/mobile.utils';

const TAG_SELECTOR = 'name="apple-itunes-app"';

/** Keeps Safari's Smart App Banner pointed at the current page so "Open" lands on the same screen in the app. */
@Injectable({ providedIn: 'root' })
export class SmartAppBannerService {
  private navSub: Subscription | null = null;

  constructor(private meta: Meta, @Inject(PLATFORM_ID) private platformId: object) {}

  /** Browser-only and idempotent: one NavigationEnd subscription for the app's lifetime. */
  start(router: Router): void {
    if (!isPlatformBrowser(this.platformId) || this.navSub) return;
    this.navSub = router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
      // Looser than isMobileApp on purpose: either signal (webview UA or ?mobile=true) omits the tag.
      const inWebView = isMobileWebView() || new URLSearchParams(window.location.search).get('mobile') === 'true';
      this.apply(window.location.href, inWebView);
    });
  }

  apply(currentUrl: string, inWebView: boolean): void {
    if (inWebView) {
      this.meta.removeTag(TAG_SELECTOR);
      return;
    }
    this.meta.updateTag({
      name: 'apple-itunes-app',
      content: `app-id=${APP_STORE_ID}, app-argument=${currentUrl}`,
    });
  }
}
